import React from "react";
import { useNavigate } from "react-router-dom";

export function PageHeader({ title, subtitle, right }) {
  return (
    <header className="px-4 md:px-10 pt-6 md:pt-10 pb-5 md:pb-7 md:sticky md:top-0 z-10 flex flex-col md:flex-row md:items-end md:justify-between gap-3 fade-in page-header-sticky">
      <div className="min-w-0">
        <h1 className="text-[24px] md:text-[32px] font-semibold tracking-tight truncate" style={{ color: "var(--text-primary)", letterSpacing: "-0.03em" }}>
          {title}
        </h1>
        {subtitle && (
          <p className="text-[13px] md:text-[14.5px] mt-1 md:mt-1.5" style={{ color: "var(--text-secondary)" }}>
            {subtitle}
          </p>
        )}
      </div>
      {right && <div className="flex items-center gap-2 flex-wrap">{right}</div>}
    </header>
  );
}

export function Tile({ children, className = "", testId }) {
  return (
    <div className={`tile p-6 fade-in ${className}`} data-testid={testId}>
      {children}
    </div>
  );
}

export function KPI({ label, value, sub, accent = false, testId, onClick }) {
  return (
    <div
      className={`tile p-6 fade-in ${onClick ? "cursor-pointer transition-transform hover:-translate-y-0.5" : ""}`}
      data-testid={testId}
      onClick={onClick}
      role={onClick ? "button" : undefined}
    >
      <div className="label-tech">{label}</div>
      <div
        className="mt-3 num text-[34px] font-semibold leading-none"
        style={{
          color: accent ? "var(--accent)" : "var(--text-primary)",
          letterSpacing: "-0.03em",
        }}
      >
        {value}
      </div>
      {sub && (
        <div className="mt-3 text-[12px]" style={{ color: "var(--text-tertiary)" }}>
          {sub}
        </div>
      )}
    </div>
  );
}

export function StatusPill({ status }) {
  const k = (status || "Unknown").toLowerCase();
  let cls = "pill-unknown";
  if (k === "hot") cls = "pill-hot";
  else if (k === "warm") cls = "pill-warm";
  else if (k === "cold") cls = "pill-cold";
  else if (k === "past/now") cls = "pill-past";
  return <span className={`pill ${cls}`} data-testid={`status-${k}`}>{status || "Unknown"}</span>;
}

export function Loading({ text = "Loading…" }) {
  return (
    <div className="p-12 text-[13px] font-mono flex items-center gap-3" style={{ color: "var(--text-tertiary)" }}>
      <div className="h-2 w-2 rounded-full animate-pulse" style={{ background: "var(--accent)" }} />
      {text}
    </div>
  );
}

export function EmptyState({ title, hint }) {
  return (
    <div className="tile p-12 text-center">
      <div className="label-tech" style={{ color: "var(--text-tertiary)" }}>{title}</div>
      {hint && <div className="text-sm mt-2" style={{ color: "var(--text-secondary)" }}>{hint}</div>}
    </div>
  );
}

export function OperatorLink({ name, className = "", style }) {
  const navigate = useNavigate();
  if (!name) return <span style={{ color: "var(--text-tertiary)" }}>—</span>;
  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        navigate(`/operators/${encodeURIComponent(name)}`);
      }}
      className={`hover:underline text-left font-medium transition-colors hover:text-[var(--accent)] ${className}`}
      style={{ color: "var(--text-primary)", ...style }}
      data-testid={`operator-link-${name}`}
      title={name}
    >
      {name}
    </button>
  );
}
